import InstalledRouter from '@/system/init/init-router';

const Welcome = () => import('../views/welcome');
const Login = () => import('../views/login');
const Account = () => import('../views/account');
const OrderList = () => import('../components/orderList');
const Coupon = () => import('../components/coupon');
const Products = () => import('../views/models/models');
const ProductInfo = () => import('../views/productInfo/index');
const EvInfo = () => import('../views/evInfo/index');
const InitOrder = () => import('../views/createOrder/index');
const Search = () => import('../views/search/index');
const OrderResult = () => import('../views/orderResult/index');
const OrderCompletion = OrderResult;
const D404 = () => import('@/core/404/index');
const AccountManage = () => import('../views/account/manage');
const UpdateTel = () => import('../views/account/updateTel');
const Wallet = () => import('../views/account/wallet/index');
const Deblock = () => import('../views/deblock');
const YearNotice = () => import('../views/activies/yearNotice');

export function createRouter () {
  return new InstalledRouter({
    keepQuerys: ['pid', 'isTranslucentBar', 'bd_vid'],
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'Welcome',
        component: Welcome,
        meta: {
          commonHeader: true,
          commonFooter: true,
          logoSearch: true
        }
      },
      {
        path: '/banner-deblock',
        name: 'Deblock',
        component: Deblock,
        meta: {
          commonHeader: true,
          commonFooter: true,
          logoSearch: true
        }
      },
      {
        path: '/Login',
        name: 'Login',
        component: Login,
        meta: {
          commonHeader: false,
          commonFooter: false
        }
      },
      {
        path: '/UpdateTel',
        name: 'UpdateTel',
        component: UpdateTel,
        meta: {
          title: '更改手机号',
          commonHeader: true,
          commonFooter: true,
          logoSearch: true,
          requiresAuth: true
        }
      },
      {
        path: '/Account',
        component: Account,
        children: [
          {
            path: '',
            name: 'AccountManage',
            component: AccountManage,
            meta: {
              commonHeader: true,
              commonFooter: true,
              logoSearch: true,
              title: '账户管理'
            }
          },
          {
            path: 'OrderList',
            name: 'OrderList',
            component: OrderList,
            meta: {
              commonHeader: true,
              commonFooter: true,
              title: '我的订单',
              logoSearch: true,
              requiresAuth: true
            }
          },
          {
            path: 'Coupon',
            name: 'Coupon',
            component: Coupon,
            meta: {
              commonHeader: true,
              commonFooter: true,
              title: '我的现金券',
              logoSearch: true,
              requiresAuth: true
            }
          },
          {
            path: 'Wallet',
            name: 'Wallet',
            component: Wallet,
            meta: {
              commonHeader: true,
              commonFooter: true,
              title: '我的钱包',
              logoSearch: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: '/search',
        name: 'search',
        component: Search,
        meta: {
          title: '机型搜索',
          commonHeader: true,
          commonFooter: true,
          logoSearch: true
        }
      },
      {
        path:
          '/products/:categoryId(\\d+)?/:brandId(\\-\\d|\\d+)?/:pageIndex(\\d+)?',
        name: 'Products',
        component: Products,
        props: true,
        alias: '/phone',
        meta: {
          getBrandName (meta, store) {
            return store ? store.getters['models/brandName'] : '';
          },
          getClassName (meta, store) {
            return store ? store.getters['models/className'] : '';
          },
          title (meta, store) {
            const tpl =
              '二手{{ brandName }}高价回收网_值得信赖的手机数码回收专家 - 回收宝';
            return tpl.replace(
              /{{ brandName }}/g,
              meta.getBrandName(meta, store)
            );
          },
          keywords (meta, store) {
            const tpl =
              '{{ brandName }}{{ className }}回收、二手{{ brandName }}{{ className }}回收、废旧{{ brandName }}{{ className }}回收、二手{{ brandName }}{{ className }}估价、二手{{ brandName }}{{ className }}交易、{{ brandName }}{{ className }}回收价格';
            return tpl
              .replace(
                /{{ brandName }}/g,
                meta.getBrandName(meta, store)
              )
              .replace(
                /{{ className }}/g,
                meta.getClassName(meta, store)
              );
          },
          description (meta, store) {
            const tpl =
              '回收宝是国内领先的二手手机数码回收平台，专业的{{ brandName }}二手{{ className }}回收平台。网站业务包括：{{ brandName }}{{ className }}回收、二手{{ brandName }}{{ className }}回收、废旧{{ brandName }}{{ className }}回收、二手{{ brandName }}{{ className }}估价、二手{{ brandName }}{{ className }}交易、{{ brandName }}{{ className }}回收价格。回收宝客服专线：400-080-9966';
            return tpl
              .replace(
                /{{ brandName }}/g,
                meta.getBrandName(meta, store)
              )
              .replace(
                /{{ className }}/g,
                meta.getClassName(meta, store)
              );
          },
          commonHeader: true,
          commonFooter: true,
          logoSearch: true
        }
      },
      {
        path: '/evaluate/:productId.html',
        name: 'ProductInfo',
        component: ProductInfo,
        props: true,
        meta: {
          getProductName (meta, store) {
            return store ? store.state.productParam.params.productName : '';
          },
          title (meta, store) {
            const str = '二手{{ productName }}高价回收网_值得信赖的手机数码回收专家 - 回收宝';
            return str.replace(/{{ productName }}/g, meta.getProductName(meta, store));
          },
          keywords (meta, store) {
            const str = '{{ productName }}手机回收、二手{{ productName }}手机回收、废旧{{ productName }}手机回收、二手{{ productName }}手机估价、二手{{ productName }}手机交易、{{ productName }}手机回收价格';
            return str.replace(/{{ productName }}/g, meta.getProductName(meta, store));
          },
          description (meta, store) {
            const str = '回收宝是国内领先的二手手机数码回收平台，专业的{{ productName }}二手手机回收平台。网站业务包括：{{ productName }}手机回收、二手{{ productName }}手机回收、废旧{{ productName }}手机回收、二手{{ productName }}手机估价、二手{{ productName }}手机交易、{{ productName }}手机回收价格。回收宝客服专线：400-080-9966';
            return str.replace(/{{ productName }}/g, meta.getProductName(meta, store));
          },
          recycleIndex: 1,
          commonHeader: true,
          commonFooter: true
        }
      },
      {
        path: '/evInfo/:evID',
        name: 'EvInfo',
        component: EvInfo,
        meta: {
          title: '估价结果',
          recycleIndex: 2,
          commonHeader: true,
          commonFooter: true
        }
      },
      {
        path: '/initOrder/:evID',
        name: 'InitOrder',
        component: InitOrder,
        meta: {
          title: '提交订单',
          recycleIndex: 2,
          requiresAuth: false,
          commonHeader: true,
          commonFooter: true
        }
      },
      {
        path: '/orderCompletion/:orderNum',
        name: 'OrderCompletion',
        component: OrderCompletion,
        meta: {
          title: '提交订单',
          recycleIndex: 3,
          requiresAuth: false,
          commonHeader: true,
          commonFooter: true
        }
      },
      {
        path: '/OrderResult/:orderNum',
        name: 'OrderResult',
        component: OrderResult,
        meta: {
          title: '提交订单',
          recycleIndex: 3,
          requiresAuth: false,
          commonHeader: true,
          commonFooter: true
        }
      },
      {
        path: '/yearNotice',
        name: 'yearNotice',
        component: YearNotice,
        meta: {
          title: '春节公告',
          keywords: '手机回收、二手手机回收、废旧手机回收、二手手机估价、二手手机交易、手机回收价格',
          description: '回收宝是国内领先的二手手机数码回收平台，专业的二手手机回收平台。网站业务包括：手机回收、二手手机回收、废旧手机回收、二手手机估价、二手手机交易、手机回收价格。回收宝客服专线：400-080-9966',
          commonHeader: true,
          commonFooter: true,
          logoSearch: true
        }
      },
      {
        path: '*',
        name: '404',
        component: D404,
        meta: {
          title: 'title'
        }
      }
    ]
  });
};



// WEBPACK FOOTER //
// ./src/projects/hsbpc/router/index.js